import React, { useContext } from "react";
import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
// import SocketIOContext from "./contexts/Kiosk/SocketProvider/SocketIOContext";
import { formatNumber } from "./Shared/PhoneFormatHelper";

import { Button, Grid, Typography, IconButton, TextField } from "@mui/material";

import PhoneInput, {
  isPossiblePhoneNumber,
  formatPhoneNumber
} from "react-phone-number-input";

const steps = ["", "", "", ""];

// props has activeStep
export default function PhoneDisplay(props) {
  // console.log(
  //   "PhoneDisplay",
  //   "props.value",
  //   props.value,
  //   formatPhoneNumber("+1" + props.value)
  // );
  const { getKioskTheme } = useContext(SocketIOContext);
  const kiosktheme = getKioskTheme();

  const telephonebuttonpress = event => {};

  // const formatNumber = (number, template) => {
  //   const digits = number.replace(/\D/g, "");
  //   let result = template;
  //   let digitIndex = 0;

  //   // Fill the template with available digits
  //   for (let i = 0; i < result.length; i++) {
  //     if (result[i] === "_" && digitIndex < digits.length) {
  //       result =
  //         result.substring(0, i) + digits[digitIndex] + result.substring(i + 1);
  //       digitIndex++;
  //     }
  //   }

  //   // Append remaining digits with spaces if there are overflow digits
  //   if (digitIndex < digits.length) {
  //     const remainingDigits = digits.slice(digitIndex);
  //     result += " " + remainingDigits;
  //   }

  //   return result;
  // };

  const customPhoneDisplay = number => {
    const phoneFormat = kiosktheme.phoneFormat;

    const display = formatNumber(number, phoneFormat);

    // let display = number.padEnd(10, "_");

    // display =
    //   "(" +
    //   display.substring(0, 3) +
    //   ") " +
    //   display.substring(3, 6) +
    //   "-" +
    //   display.substring(6, 10);

    return display;
  };

  return (
    <div>
      <Typography
        variant="h4"
        style={{
          //fontSize: "clamp(18px, 6vh, 2.8em)"
          fontSize: "5vh",
          whiteSpace: "nowrap",
          // fontSize: "3em"
          width: "100%"
        }}
      >
        <center>{customPhoneDisplay(props.value)}</center>
      </Typography>
    </div>
  );
}
